import { JobType, JobTaskType } from "@augmodo/lebron-browser-client";

export const PLAY_MODE_TABS = new Set([
  "confirmation",
  "confirmation-qa",
  "coverage",
  "coverage-beta",
  "coverage-qa",
  "coverage-beta-qa",
  "box-draw",
  "my-tasks",
]);

// Maps a task's type to the route segment that renders it. Shared by the
// "My Tasks" list and its task-driven play mode.
export const TASK_TYPE_ROUTE: Record<string, string> = {
  [JobTaskType.OUT_OF_STOCK_CONFIRMATION]: "confirmation",
  // String literals until @augmodo/lebron-browser-client is regenerated from a
  // prod lebron that has these benchmark/QA enum members.
  OUT_OF_STOCK_CONFIRMATION_BENCHMARK: "confirmation",
  COVERAGE_REVIEW_BENCHMARK: "coverage",
  COVERAGE_REVIEW_BETA_QA: "coverage-beta-qa",
  [JobTaskType.OUT_OF_STOCK_CONFIRMATION_QA]: "confirmation-qa",
  [JobTaskType.OUT_OF_STOCK_SELECTION]: "selection",
  [JobTaskType.OUT_OF_STOCK_BOX_DRAW]: "box-draw",
  [JobTaskType.COVERAGE_REVIEW]: "coverage",
  [JobTaskType.COVERAGE_REVIEW_QA]: "coverage-qa",
};

export const BENCHMARK_JOB_TYPE_ROUTE: Record<string, string> = {
  OUT_OF_STOCK_CONFIRMATION_BENCHMARK_TASKS: "confirmation",
  COVERAGE_REVIEW_BENCHMARK_TASKS: "coverage",
};

// Friendly family name for a benchmark quiz job's own type — shown in quiz
// listings that mix families (My Quizzes, Manage Quizzes) so a row identifies
// which kind of quiz it is.
export const BENCHMARK_JOB_TYPE_LABEL: Record<string, string> = {
  OUT_OF_STOCK_CONFIRMATION_BENCHMARK_TASKS: "Out of Stock Confirmation",
  COVERAGE_REVIEW_BENCHMARK_TASKS: "Coverage Review",
};

export const PLAY_MODE_JOB_TYPE: Record<
  string,
  { jobType: JobType; route: string }
> = {
  confirmation: {
    jobType: JobType.OUT_OF_STOCK_CONFIRMATION_TASKS,
    route: "confirmation",
  },
  "box-draw": {
    jobType: JobType.OUT_OF_STOCK_BOX_DRAW_TASKS,
    route: "box-draw",
  },
  coverage: { jobType: JobType.COVERAGE_REVIEW_TASKS, route: "coverage" },
  "confirmation-qa": {
    jobType: JobType.OUT_OF_STOCK_CONFIRMATION_QA_TASKS,
    route: "confirmation-qa",
  },
  "coverage-qa": {
    jobType: JobType.COVERAGE_REVIEW_QA_TASKS,
    route: "coverage-qa",
  },
  // String literal until @augmodo/lebron-browser-client picks up the enum.
  "coverage-beta-qa": {
    jobType: "COVERAGE_REVIEW_BETA_QA_TASKS" as JobType,
    route: "coverage-beta-qa",
  },
};

// Answer options for the empty-area question (Q1), used by QaQuestionAction's
// "which parts were incorrect?" multiselect. `value` is what gets stored in
// task results (matches the snake_case resultMetadata keys) — never rename
// these, reporting queries depend on them. `label` mirrors the option labels
// shown in EmptyAreaCard (radio pair + qualifier checkboxes); if you change a
// label there, update it here too.
export const EMPTY_AREA_OPTIONS = [
  { value: "is_empty_area", label: "Is Empty Area" },
  { value: "not_empty_area", label: "Not Empty Area" },
  { value: "not_main_aisle", label: "Not Main Aisle" },
  { value: "unblurred_person_in_image", label: "Unblurred Person in Image" },
  { value: "remaining_product_facings", label: "Remaining Product Facings" },
  { value: "blue_tag_present", label: "Blue Tag Present" },
];

export const SKIP_REASONS = [
  "empty area: not empty",
  "empty area: blue tag",
  "image: unblurred person",
  "image: poor quality", // (blurry, too many scan lines)
  "planogram: noncompliance",
];

export const HEADER_HEIGHT = 52;
export const RESULTS_SIDEBAR_WIDTH = 300;
export const BOX_DRAW_SIDEBAR_WIDTH = 300;
export const NAV_SIDEBAR_WIDTH_EXPANDED = 220;
export const NAV_SIDEBAR_WIDTH_COLLAPSED = 52;
